import {
  Order,
  SupplierOrder,
} from '@/shared/types/controllers/DashboardControllerTypes';

export const isSupplierOrderData = (
  order: Order | SupplierOrder,
): order is SupplierOrder => 'shipCompanyName' in order;
